import React, { useContext } from 'react'
import 'react-quill/dist/quill.snow.css'

import { CardContent, CardFooter } from '@components/layout/Card'
import { Button } from '@components/Button'

import { NotesContext } from '../../context'
import { buildNote } from '../../effects'
import '../../styles/Note.styles.sass'
import Toolbar from '../../components/Toolbar'
import NoteEditor from '../../components/NoteEditor'

const baseClass = 'scenario-notes__create'

export const Create = () => {
  return (
    <>
      <CardContent className={baseClass}>
        <Main />
      </CardContent>
      <Actions />
    </>
  )
}

const Main = () => {
  const {
    state: { noteRichText, noteTemplate, isPrivateNote, noteTemplates, withTemplates },
    actions: { onEditerChange, onToggleNoteVisibility, useTemplate }
  } = useContext(NotesContext)

  const handleChange = (value) => {
    onEditerChange(value)
  }

  const showNoteTemplates = withTemplates && noteTemplates.length > 0

  return (
    <div className={`${baseClass}-main`}>
      <Toolbar
        isPrivateNote={isPrivateNote}
        noteTemplates={showNoteTemplates && noteTemplates}
        useTemplate={showNoteTemplates && useTemplate}
        onToggleNoteVisibility={onToggleNoteVisibility} />
      <NoteEditor
        locked={noteTemplate?.isLocked}
        value={noteRichText}
        onChange={handleChange}
      />
    </div>
  )
}

/* Disabling the submit button is slightly tricky. ~value~ is initially
 * an empty string, which is falsy. However, when the user types something,
 * and then removes everything, the value is '<p><br></p>', with extra
 * <br>'s for each empty line. For now, the user will be able to submit a note
 * with more than 1 empty line.
 */
const Actions = () => {
  const {
    state: { noteRichText, noteTemplate, isPrivateNote, loading },
    actions: { back, createNote }
  } = useContext(NotesContext)

  const onCreate = () => {
    createNote(
      buildNote(
        {
          body: noteRichText,
          visibility: isPrivateNote ? 1 : 0,
          noteTemplate: noteTemplate 
        }
      )
    )
  }
  return (
    <CardFooter>
      <div className={`${baseClass}-actions`}>
        <Button fullWidth secondary onClick={back}>
          Back
        </Button>
        <Button
          fullWidth
          primary
          disabled={!noteRichText || noteRichText === '<p><br></p>' || loading}
          trackAs='Create scenario note'
          onClick={onCreate}
        >
          {loading ? 'Adding note...' : "Add note" }
        </Button>
      </div>
    </CardFooter>
  )
}